<template>
	<div class="wrapper">
		<!-- 标题区域 -->
		<div class="page-header">
			<div class="header-content">
				<h2 class="page-title">
					<i class="el-icon-money title-icon"></i>
					{{ $route.meta.name }}
				</h2>
				<div class="header-stats">
					<div class="stat-item">
						<span class="stat-label">总记录数</span>
						<span class="stat-value">{{ total }}</span>
					</div>
				</div>
			</div>
		</div>
		
		<!-- 搜索区域 -->
		<el-card class="search-card" shadow="never">
			<div class="card-header-title">
				<i class="el-icon-search"></i>
				<span>筛选条件</span>
			</div>
			<div class="header-search">
				<el-form ref="form" inline :model="searchData" label-width="100px">
					<el-form-item label="门店名称">
						<el-input
							placeholder="请输入"
							v-model="searchData.storeName"
							clearable
							size="small"
							style="width: 200px"
						>
						</el-input>
					</el-form-item>
					<el-form-item label="订单号">
						<el-input
							placeholder="请输入"
							v-model="searchData.orderNo"
							clearable
							size="small"
							style="width: 200px"
						>
						</el-input>
					</el-form-item>
					<el-form-item label="客户姓名">
						<el-input
							placeholder="请输入"
							v-model="searchData.memberName"
							clearable
							size="small"
							style="width: 200px"
						>
						</el-input>
					</el-form-item>
          <el-form-item label="成交时间">
            <el-date-picker
                style="width: 350px"
                v-model="searchData.orderDealDate"
                size="small"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
					<el-form-item label="结算时间">
						<el-date-picker
							style="width: 350px"
							v-model="searchData.settleDate"
							size="small"
							type="daterange"
							value-format="yyyy-MM-dd"
							range-separator="-"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
						>
						</el-date-picker>
					</el-form-item>
					<el-form-item label="结算状态">
						<el-select
							v-model="searchData.settleStatus"
							placeholder="请选择"
							size="small"
							style="width: 200px"
							clearable
						>
							<el-option
								v-for="item in statusList"
								:key="item.value"
								:label="item.label"
								:value="item.value"
							>
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="结算方式">
						<el-select
							v-model="searchData.settleType"
							placeholder="请选择"
							size="small"
							style="width: 200px"
							clearable
						>
							<el-option
								v-for="item in payMethodsList"
								:key="item.value"
								:label="item.label"
								:value="item.value"
							>
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label=" " label-width="50px">
						<el-button
							type="primary"
							size="small"
							icon="el-icon-search"
							@click="search"
							class="search-btn"
							>搜索</el-button
						>
						<el-button
							type="info"
							size="small"
							icon="el-icon-refresh"
							@click="reset"
							class="reset-btn"
							>重置</el-button
						>
					</el-form-item>
				</el-form>
			</div>
		</el-card>

		<!-- 表格区域 -->
		<el-card class="table-card" shadow="never">
			<div class="card-header-title">
				<i class="el-icon-s-grid"></i>
				<span>结算列表</span>
				<div class="header-actions">
					<el-button
						v-checkbtn="isShowBtn(AUTH_BTN.finance_store_settle_export)"
						type="primary"
						icon="el-icon-download"
						size="small"
						@click="downloadExcel"
						class="export-btn"
						>导出</el-button
					>
				</div>
			</div>
			<tp-table
				:isNeedSerialNumber="true"
				:tableData="list"
				:columns="columns"
				:totalNum="total"
				:current-page.sync="currentPage"
				:pageSize.sync="pageSize"
			/>
		</el-card>
		<SettleDialog
			:orderNo="row.orderNo"
			:visible.sync="row.visible"
			:settleType="row.settleType"
			@ok="ok"
		/>
	</div>
</template>

<script>
import dayjs from "dayjs";
import { authBtnMixin } from "@/mixins/authBtnMixin";
import {
	getStoreSettleListAPI,
	exportAPI,
	downloadReceiptAPI,
  downloadReceiptPdf,
} from "./api";
import SettleDialog from "./settle-dialog.vue";
import {dateFormat} from "@/utils";

const columns = [
	{
		label: "门店名称",
		prop: "storeName",
		minWidth: "200",
		customRender(h, row) {
			return <p class="table-cell-text">{row["storeName"] || '-'}</p>;
		},
	},
  {
    label: "客户姓名",
    prop: "memberName",
    minWidth: "120",
    customRender(h, row) {
      return <p class="table-cell-text">{row["memberName"] || '-'}</p>;
    },
  },
  {
    label: "商品信息",
    prop: "goodsTitle",
    minWidth: "200",
    customRender(h, row) {
      return <p class="table-cell-text goods-info">{row["goodsTitle"] || '-'}</p>;
    },
  },
	{
		label: "订单号",
		prop: "orderNo",
		minWidth: "220",
		customRender(h, row) {
			return <p class="table-cell-text">{row["orderNo"] || '-'}</p>;
		},
	},
  {
    label: "成交时间",
    prop: "orderDealTime",
    minWidth: "180",
    customRender(h, row) {
      return <p class="table-cell-text">{row.orderDealTime || '-'}</p>;
    },
  },
  {
    label: "结算方式",
    prop: "settleTypeName",
    minWidth: "130",
    customRender(h, row) {
      return <p class="table-cell-text">{row.settleTypeName || '-'}</p>;
    },
  },
	{
		label: "收款账户信息",
		prop: "payeeAlipayAccount",
		minWidth: "220",
		customRender(h, row) {
			if (row.settleType === 1) {
				return <span class="table-cell-text">-</span>;
			}

			return (
				<div>
					<div class="info-item">
						<span class="label">姓名：</span>
						<span class="value">{row["payeeIdName"] || '-'}</span>
					</div>
					<div class="info-item">
						<span class="label">支付宝账号：</span>
						<span class="value">{row["payeeAlipayAccount"] || '-'}</span>
					</div>
				</div>
			);
		},
	},
	{
		label: "结算金额",
		minWidth: "120",
		prop: "settleAmount",
		customRender(h, row) {
			return <p class="table-cell-text amount-value">￥{row["settleAmount"] || '-'}</p>;
		},
	},
  {
    label: "结算时间",
    prop: "settleTime",
    minWidth: "180",
    customRender(h, row) {
      return <p class="table-cell-text">{row.settleTime || '-'}</p>;
    },
  },
  {
    label: "结算状态",
    prop: "settleStatusName",
    minWidth: "140",
    fixed: "right",
    customRender(h, row) {
      return (
        <div class="status-cell">
          <el-tag v-show={row.settleStatus == 0} type="info" size="mini">{row["settleStatusName"]}</el-tag>
          <el-tag v-show={row.settleStatus == 1} type="success" size="mini">{row["settleStatusName"]}</el-tag>
          <div v-show={row.settleStatus == 2} class="status-failed">
            <el-tag type="danger" size="mini" style="margin-right: 5px;">{row["settleStatusName"]}</el-tag>
            <el-tooltip effect="dark" placement="top-start">
              <template slot="content">
                <p style="width: 200px;">{row["settleRemark"] || '暂无信息'}</p>
              </template>
              <i class="el-icon-warning-outline warning-icon"></i>
            </el-tooltip>
          </div>
        </div>
      );
    },
  },
	{
		label: "操作",
		minWidth: "200",
		fixed: "right",
		align: "center",
		customRender(h, row) {
			return (
				<div class="action-links">
          <el-link
              v-show={
                  this.showOfflinePayBtn(row) &&
                  this.isShowBtn(
                      this.AUTH_BTN.finance_store_settle_offline_payment
                  )
              }
              underline={false}
              type="primary"
              onClick={() => this.showSettleDialog(row, 1)}
              class="action-link"
          >
            线下打款
          </el-link>
					<el-link
						v-show={
							this.onlinePayFail(row) &&
							this.isShowBtn(this.AUTH_BTN.finance_store_settle_retry)
						}
						underline={false}
						type="primary"
						onClick={() => this.showSettleDialog(row, 2)}
						class="action-link"
					>
						重试
					</el-link>
          <el-link
              underline={false}
              type="primary"
              onClick={() => this.downloadReceipt(row)}
              v-show={
                  this.onlinePaySuccess(row) &&
                  this.isShowBtn(this.AUTH_BTN.finance_store_settle_receipt_download)
              }
              class="action-link"
          >
            下载回单
          </el-link>
				</div>
			);
		},
	},
];
export default {
	name: "FinanceStoreSettle",
	mixins: [authBtnMixin],
	components: {
		SettleDialog,
	},
	data() {
		return {
			statusList: [
        {
          label: "待打款",
          value: 0,
        },
				{
					label: "打款成功",
					value: 1,
				},
				{
					label: "打款失败",
					value: 2,
				},
			],
			payMethodsList: [
				{
					label: "线下打款",
					value: 1,
				},
				// {
				// 	label: "支付宝自动结算",
				// 	value: 2,
				// },
			],
			columns,
			currentPage: 1,
			pageSize: 10,
			total: 0,
			list: [],
			searchData: {
				storeName: "", //门店名称
				orderNo: "", //订单号
				memberName: "", //客户姓名
        orderDealDate: "", //订单成交日期
				settleDate: "", //结算日期
				settleStatus: "", //结算状态
				settleType: "", //结算方式
			},
			row: {},
		};
	},
	mounted() {
		this.getList();
	},
	watch: {
		currentPage() {
			this.getList();
		},
		pageSize() {
			this.getList();
		},
	},
	methods: {
		ok() {
			this.row.visible = false;
			this.getList();
		},
		onlinePaySuccess(row) {
			return (
				row.settleType === 2 && row.settleStatus == 1 && !this.ifOverTime(row)
			);
		},
		//重试按钮展示条件
		onlinePayFail(row) {
			//线上结算：settleType=2  结算状态：settleStatus：1成功
			return row.settleType === 2 && row.settleStatus == 2; //支付失败
		},
		showOfflinePayBtn(row) {
			// 线下结算 且 订单状态大于租赁中 且 结算状态 (待打款/打款失败)   或者 线上支付 结算状态为失败
			return (row.settleType == 1 && row.orderStatus >= 6 && row.settleStatus != 1) || this.onlinePayFail(row);
		},
		ifOverTime(row) {
			if (!row.settleTime) {
				return false;
			}

			const duration = dayjs().diff(dayjs(row.settleTime), "day");

			return duration > 365;
		},
		showSettleDialog(row, settleType) {
			this.row = {
				orderNo: row.orderNo,
				visible: true,
				settleType,
			};
		},
		search() {
			this.getList();
		},
		async getList() {
			let params = {
				page: this.currentPage,
				pageSize: this.pageSize,
				...this.searchData,
			};
      if (this.searchData.orderDealDate && this.searchData.orderDealDate.length > 0) {
        params.leftOrderDealDate = this.searchData.orderDealDate[0];
        params.rightOrderDealDate = this.searchData.orderDealDate[1];
        params.orderDealDate = '';
      }
			if (this.searchData.settleDate && this.searchData.settleDate.length > 0) {
				params.leftSettleDate = this.searchData.settleDate[0];
				params.rightSettleDate = this.searchData.settleDate[1];
				params.settleDate = '';
			}
			const res = await getStoreSettleListAPI(params);
			this.list = res.list || [];
			this.total = res.total || 0;
		},
		downloadExcel() {
			let params = { ...this.searchData };
      if (this.searchData.orderDealDate && this.searchData.orderDealDate.length > 0) {
        params.leftOrderDealDate = this.searchData.orderDealDate[0];
        params.rightOrderDealDate = this.searchData.orderDealDate[1];
        params.orderDealDate = '';
      }
			if (this.searchData.settleDate && this.searchData.settleDate.length > 0) {
				params.leftSettleDate = this.searchData.settleDate[0];
				params.rightSettleDate = this.searchData.settleDate[1];
				params.settleDate = '';
			}
			exportAPI(params);
		},
		reset() {
			Object.assign(this._data.searchData, this.$options.data().searchData);
			this.getList();
		},
		async downloadReceipt(row) {
			const res = await downloadReceiptAPI({ orderNo: row.orderNo });
      downloadReceiptPdf(res.receiptFileUrl, `结算回单${row.orderNo}-${dateFormat()}.pdf`)
		},
	},
};
</script>

<style lang="scss" scoped>
.wrapper {
	width: 100%;
	background: linear-gradient(180deg, #f0f2f5 0%, #fafbfc 50%, #ffffff 100%);
	padding: 20px;
	min-height: calc(100vh - 84px);
	position: relative;
	
	&::before {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		height: 200px;
		background: linear-gradient(135deg, rgba(64, 158, 255, 0.05) 0%, rgba(102, 177, 255, 0.02) 100%);
		pointer-events: none;
		z-index: 0;
	}
}

// 页面标题区域
.page-header {
	margin-bottom: 20px;
	position: relative;
	z-index: 1;
	
	.header-content {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 12px 24px;
		background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
		border-radius: 16px;
		box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04), 0 8px 24px rgba(0, 0, 0, 0.06);
		border: 1px solid rgba(255, 255, 255, 0.8);
		backdrop-filter: blur(10px);
	}
	
	.page-title {
		margin: 0;
		font-size: 20px;
		font-weight: 700;
		color: #1a1e25;
		display: flex;
		align-items: center;
		gap: 12px;
		letter-spacing: -0.5px;
		
		.title-icon {
			font-size: 24px;
			background: linear-gradient(135deg, #409EFF 0%, #66b1ff 100%);
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;
			background-clip: text;
		}
	}
	
	.header-stats {
		display: flex;
		gap: 24px;
		
		.stat-item {
			display: flex;
			flex-direction: row;
			align-items: center;
			gap: 8px;
			padding: 4px 14px;
			background: linear-gradient(135deg, #f0f7ff 0%, #e6f2ff 100%);
			border-radius: 10px;
			border: 1px solid rgba(64, 158, 255, 0.15);
			
			.stat-label {
				font-size: 12px;
				color: #909399;
				margin-right: 8px;
			}
			
			.stat-value {
				font-size: 16px;
				font-weight: 700;
				color: #409EFF;
				line-height: 1;
			}
		}
	}
}

// 卡片标题样式
.card-header-title {
	display: flex;
	align-items: center;
	justify-content: flex-start;
	gap: 8px;
	font-size: 16px;
	font-weight: 600;
	color: #303133;
	margin-bottom: 20px;
	padding-bottom: 12px;
	border-bottom: 2px solid #f0f2f5;
	
	i {
		font-size: 18px;
		color: #409EFF;
	}
	
	.header-actions {
		display: flex;
		gap: 12px;
		margin-left: auto;
		
		.export-btn {
			border-radius: 10px;
			padding: 9px 20px;
			font-weight: 600;
			font-size: 13px;
			background: linear-gradient(135deg, #67c23a 0%, #5daf34 100%);
			border: none;
			box-shadow: 0 2px 8px rgba(103, 194, 58, 0.3);
			transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
			
			&:hover {
				transform: translateY(-2px);
				background: linear-gradient(135deg, #5daf34 0%, #529b2e 100%);
				box-shadow: 0 4px 12px rgba(103, 194, 58, 0.4);
			}
		}
	}
}

// 搜索卡片样式
.search-card {
	margin-bottom: 20px;
	border-radius: 16px;
	border: none;
	background: #ffffff;
	box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06), 0 1px 4px rgba(0, 0, 0, 0.04);
	transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
	position: relative;
	z-index: 1;
	overflow: hidden;
	
	&::before {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		height: 3px;
		background: linear-gradient(90deg, #409EFF 0%, #66b1ff 50%, #85c1ff 100%);
	}

	&:hover {
		box-shadow: 0 8px 28px rgba(0, 0, 0, 0.1), 0 2px 8px rgba(0, 0, 0, 0.06);
		transform: translateY(-2px);
	}

	::v-deep .el-card__body {
		padding: 24px 28px;
	}

	.header-search {
		.el-form {
			.el-form-item {
				margin-right: 15px;
				margin-bottom: 10px;
				
				.el-form-item__label {
					color: #303133;
					font-weight: 600;
					letter-spacing: 0.3px;
					font-size: 14px;
					position: relative;
					
					&::after {
						content: ':';
						margin-left: 2px;
						color: #909399;
					}
				}
				
				.el-input,
				.el-select {
					transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
					
					.el-input__inner {
						border-radius: 10px;
						height: 38px;
						line-height: 38px;
						border: 1.5px solid #E4E7ED;
						transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
						background: #fafbfc;
						font-size: 13px;

						&:hover {
							border-color: #C0C4CC;
							background: #ffffff;
						}
					}
					
					&.is-active .el-input__inner,
					.el-input__inner:focus {
						border-color: #409EFF;
						box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.15);
						background: #ffffff;
					}
				}
				
				.el-date-editor {
					transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
					
					.el-range-separator {
						padding: 0 10px;
						color: #606266;
						font-weight: 500;
					}
					
					.el-range-input {
						width: 35%;
						font-size: 13px;
					}
					
					.el-input__inner {
						border-radius: 10px;
						height: 38px;
						border: 1.5px solid #E4E7ED;
						background: #fafbfc;
					}
					
					&:hover .el-input__inner {
						border-color: #C0C4CC;
						background: #ffffff;
					}

					&.is-active,
					&:focus-within {
						box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.15);
						border-radius: 10px;
						
						.el-input__inner {
							background: #ffffff;
						}
					}
				}
			}
			
			.search-btn {
				border-radius: 10px;
				padding: 10px 24px;
				font-weight: 600;
				font-size: 13px;
				background: linear-gradient(135deg, #66b1ff 0%, #409EFF 100%);
				border: none;
				box-shadow: 0 4px 14px rgba(64, 158, 255, 0.35), 0 2px 6px rgba(64, 158, 255, 0.2);
				transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
				letter-spacing: 0.3px;

				&:hover {
					background: linear-gradient(135deg, #409EFF 0%, #337ecc 100%);
					box-shadow: 0 6px 20px rgba(64, 158, 255, 0.45), 0 3px 8px rgba(64, 158, 255, 0.25);
					transform: translateY(-2px);
				}

				&:active {
					transform: translateY(0);
					box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
				}
			}

			.reset-btn {
				border-radius: 10px;
				padding: 10px 24px;
				font-weight: 600;
				font-size: 13px;
				background: linear-gradient(135deg, #a4a9b0 0%, #909399 100%);
				border: none;
				box-shadow: 0 4px 12px rgba(144, 147, 153, 0.25);
				transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
				letter-spacing: 0.3px;

				&:hover {
					background: linear-gradient(135deg, #909399 0%, #82848a 100%);
					box-shadow: 0 6px 16px rgba(144, 147, 153, 0.35);
					transform: translateY(-2px);
				}

				&:active {
					transform: translateY(0);
					box-shadow: 0 2px 8px rgba(144, 147, 153, 0.25);
				}
			}
		}
	}
}

// 表格卡片样式
.table-card {
	border-radius: 16px;
	border: none;
	background: #ffffff;
	box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06), 0 1px 4px rgba(0, 0, 0, 0.04);
	transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
	position: relative;
	z-index: 1;
	overflow: hidden;
	
	&::before {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		height: 3px;
		background: linear-gradient(90deg, #67C23A 0%, #85ce61 50%, #95d475 100%);
	}

	&:hover {
		box-shadow: 0 8px 28px rgba(0, 0, 0, 0.1), 0 2px 8px rgba(0, 0, 0, 0.06);
		transform: translateY(-2px);
	}

	::v-deep .el-card__body {
		padding: 24px;
	}

	::v-deep .tp-table {
		.el-table {
			border-radius: 12px;
			overflow: hidden;
			border: 1px solid #EBEEF5;
			background: #ffffff;

			th {
				background: linear-gradient(180deg, #F8FAFF 0%, #F0F4FF 100%);
				color: #303133;
				font-weight: 700;
				padding: 18px 0;
				border-bottom: 2px solid #E4E7ED;
				letter-spacing: 0.3px;
				text-transform: uppercase;
				font-size: 12px;
				
				&:first-child {
					padding-left: 20px;
				}
			}

			tbody {
				tr {
					transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
					border-bottom: 1px solid #F0F2F5;

					&:hover > td {
						background: linear-gradient(90deg, #F5F7FA 0%, #FAFBFC 100%) !important;
					}
					
					&:last-child {
						border-bottom: none;
					}

					td {
						padding: 18px 0;
						border-bottom: 1px solid #F5F7FA;
						
						&:first-child {
							padding-left: 20px;
						}
						
						.info-item {
							display: flex;
							align-items: center;
							margin-bottom: 8px;
							line-height: 1.5;
							
							&:last-child {
								margin-bottom: 0;
							}
							
							.label {
								color: #909399;
								font-size: 13px;
								min-width: 90px;
								flex-shrink: 0;
							}
							
							.value {
								color: #303133;
								font-weight: 500;
								word-break: break-all;
							}
						}
						
						.table-cell-text {
							margin: 0;
							color: #606266;
							font-size: 13px;
							line-height: 1.8;
							font-weight: 400;
						}
						
						.goods-info {
							display: flex;
							word-break: break-all;
						}
						
						.amount-value {
							color: #303133;
							font-weight: 600;
							font-size: 14px;
						}
						
						.status-cell {
							display: flex;
							align-items: center;
							
							.status-failed {
								display: flex;
								align-items: center;
								
								.warning-icon {
									color: #f56c6c;
									font-size: 16px;
									cursor: pointer;
									transition: all 0.3s ease;
									
									&:hover {
										color: #f78989;
										transform: scale(1.1);
									}
								}
							}
						}
						
						.action-links {
							display: flex;
							flex-wrap: wrap;
							gap: 8px;
							justify-content: center;
							
							.action-link {
								font-weight: 500;
								transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
								
								&:hover:not(.is-disabled) {
									transform: translateY(-1px);
									color: #66b1ff;
								}
								
								&.is-disabled {
									opacity: 0.5;
									cursor: not-allowed;
								}
							}
						}
					}
				}
			}
		}
		
		.el-table__fixed-right {
			height: 100% !important;
		}

		.pagination {
			margin-top: 24px;
			padding: 20px 0 0;
			border-top: 2px solid #F0F2F5;
			
			::v-deep .el-pagination {
				.el-pagination__total {
					color: #606266;
					font-weight: 500;
				}
				
				.btn-prev,
				.btn-next {
					border-radius: 6px;
					transition: all 0.3s ease;
					
					&:hover {
						background: #F5F7FA;
						color: #409EFF;
					}
				}
				
				.el-pager li {
					border-radius: 6px;
					transition: all 0.3s ease;
					
					&:hover {
						color: #409EFF;
						background: #F5F7FA;
					}
					
					&.active {
						background: linear-gradient(135deg, #66b1ff 0%, #409EFF 100%);
						color: #ffffff;
						font-weight: 600;
						box-shadow: 0 2px 6px rgba(64, 158, 255, 0.3);
					}
				}
				
				.el-select .el-input__inner {
					border-radius: 6px;
					border-color: #DCDFE6;
					
					&:hover {
						border-color: #C0C4CC;
					}
				}
				
				.el-input__inner {
					border-radius: 6px;
					border-color: #DCDFE6;
					
					&:hover {
						border-color: #C0C4CC;
					}
					
					&:focus {
						border-color: #409EFF;
						box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.15);
					}
				}
			}
		}
	}
}

// 响应式设计
@media (max-width: 1400px) {
	.search-card .header-search .el-form ::v-deep {
		.el-form-item {
			margin-right: 12px;
		}
	}
	
	.page-header .header-content {
		flex-direction: column;
		align-items: flex-start;
		gap: 16px;
		
		.header-stats {
			width: 100%;
			justify-content: flex-start;
		}
	}
}

@media (max-width: 768px) {
	.wrapper {
		padding: 12px;
	}
	
	.page-header .header-content {
		padding: 16px;
		
		.page-title {
			font-size: 20px;
		}
	}
	
	.search-card,
	.table-card {
		border-radius: 12px;
		
		::v-deep .el-card__body {
			padding: 16px;
		}
	}
}
</style>
